import { useQuery } from 'react-query';
import {
  PrdDataStaticWeightedData,
  PrdDataStaticWeightedData2,
  StreamDetailsData,
  StreamDetailsData2,
  StreamListData,
} from 'components/PerformanceReturns/Mock';
import {
  DEFAULT_DATE_FORMAT_WITH_TIME,
  dateISOStringToFormat,
  dateToServer,
} from 'helpers/formatters/date';
import { PerformanceReturnDetails, Stream } from 'types/PerformanceReturns';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
// import { axiosClient } from './axiosClient';

// const resource = 'streams';

export type GetStreamDetailsProps = {
  streamId?: string;
  calcFrequency?: number;
  startDate?: Date;
  endDate?: Date;
};

// TODO: This is to mimic network latency. Used in the mock calls below.
async function stall(stallTime = 3000) {
  await new Promise((resolve) => setTimeout(resolve, stallTime));
}

// TODO: API endpoints are accurate from the RFC as of 2023/05/26
// Can delete mock calls `async () => {...` and uncomment out axiosClient calls.
const streams = {
  GetStreams(benchmarkId?: string) {
    const [dataEnvironment] = useDataEnvironment();

    return useQuery(
      ['streams', dataEnvironment?.id],
      async () => {
        await stall(500);
        return Promise.resolve(StreamListData);
      },
      // () =>
      //   axiosClient.get<StreamListData>(
      //     `${dataEnvironment?.id}/${resource}?benchmarkId=${benchmarkId}`
      //   ),
      {
        select: (data) =>
          data?.data
            ?.sort((a, b) => b.dateCreated.localeCompare(a.dateCreated))
            .map((ele: Stream) => ({
              ...ele,
              label: dateISOStringToFormat(
                ele.dateCreated,
                DEFAULT_DATE_FORMAT_WITH_TIME
              ),
              value: ele.dateCreated,
            })),
      }
    );
  },
  GetStreamDetails({
    streamId,
    calcFrequency,
    startDate,
    endDate,
  }: GetStreamDetailsProps) {
    const [dataEnvironment] = useDataEnvironment();

    let queryParamsObj: any = {};
    if (startDate) {
      queryParamsObj.startDate = dateToServer(startDate);
    }
    if (endDate) {
      queryParamsObj.endDate = dateToServer(endDate);
    }

    if (calcFrequency) {
      queryParamsObj.calcFrequency = calcFrequency;
    }

    const queryParams = new URLSearchParams(queryParamsObj);

    console.log(streamId, queryParams.toString());

    return useQuery(
      ['streamDetails', dataEnvironment?.id, streamId],
      async () => {
        await stall(1500);
        return Promise.resolve(
          streamId
            ? streamId === '1'
              ? StreamDetailsData
              : StreamDetailsData2
            : undefined
        );
      },

      // () =>
      //   axiosClient.get<StreamDetailsData>(
      //     `${dataEnvironment?.id}/${resource}/${streamId}?${queryParams.toString()}`
      //   ),
      {
        select: (data) => {
          data?.data.performanceReturns?.sort((a, b) =>
            b.date.localeCompare(a.date)
          );
          return data?.data;
        },
      }
    );
  },
  GetPerformanceReturnDetails(streamId?: string, asOfDate?: string) {
    const [dataEnvironment] = useDataEnvironment();

    return useQuery(
      ['streams', dataEnvironment?.id, streamId],
      async () => {
        await stall(1500);
        return Promise.resolve(
          streamId
            ? streamId === '1'
              ? (PrdDataStaticWeightedData as PerformanceReturnDetails)
              : (PrdDataStaticWeightedData2 as PerformanceReturnDetails)
            : undefined
        );
      }
      // () =>
      //   axiosClient.get<PerformanceReturnDetails(
      //     `${dataEnvironment?.id}/${resource}/${streamId}/performanceReturns/${asOfDate}`
      //   ),
    );
  },
};

export default streams;
